<template lang="html">
  <div>
    <br>
    <v-layout align-center justify-center>
      <v-flex xs12 lg8>
        <v-layout row wrap justify-space-between>
          <v-flex xs6>
            <c-readonly-field
            label="Unidade"
            :value="extensaoe.unidade ? (extensaoe.unidade.nome + (extensaoe.unidade.siglaUnidade == null ? '' : ' - ' + extensao.unidade.siglaUnidade )) : '-'"
            ></c-readonly-field>
          </v-flex>
          <v-flex xs6>
            <c-readonly-field
            label="Órgão competente pela aprovação"
            :value="extensaoe.orgaoCompetente ? extensaoe.orgaoCompetente : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-space-between>
          <v-flex xs6>
            <c-readonly-field
            label="Coordenado por"
            :value="extensaoe.coordenadoPor ? extensaoe.coordenadoPor.descricao : '-'"
            ></c-readonly-field>
          </v-flex>
          <v-flex xs6>
            <c-readonly-field
            label="Data da primeira apresentação"
            :value="extensaoe.dtPrimeiraApresentacao ? dates.format(extensaoe.dtPrimeiraApresentacao) || '-' : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-space-between>
          <v-flex xs6>
            <c-readonly-field
            label="Data da última revisão"
            :value="extensaoe.dtRevisao ? dates.format(extensaoe.dtRevisao) || '-' : '-'"
            ></c-readonly-field>
          </v-flex>

          <!--v-flex-- xs6>
            <c-readonly-field
            label="Data de aprovação pela Câmara de Extensão"
            :value="extensaoe.dtAprovacao ? dates.format(extensaoe.dtAprovacao) || '-' : '-'"
            ></c-readonly-field>
          </!--v-flex-->
        </v-layout>

        <v-layout row v-if="projeto.situacao.item === 17">
          <v-flex xs12>
            <c-readonly-field
            label="Data de inabilitação pela Câmara de Extensão"
            :value="extensaoe.dtInabilitacao ? dates.format(extensaoe.dtInabilitacao) || '-' : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout v-if="extensaoe.evento" row wrap justify-space-between>
          <v-flex xs6>
            <c-readonly-field
            label="Tipo de Evento"
            :value="extensaoe.tipoEvento ? extensaoe.tipoEvento.descricao : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- O programa é uma Empresa Júnior? -->
        <v-layout v-if="projeto.classificacaoSecundaria.id === 39733" row>
          <v-flex xs12>
            <c-readonly-field
            label="O programa é uma Empresa Júnior?"
            :value="extensaoe.empresaJunior != null ? (extensaoe.empresaJunior ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Texto informativo sobre o cadastro de empresas juniores como programas -->
        <v-layout v-if="projeto.classificacaoSecundaria.id === 39733" row>
          <v-flex xs12>
            <v-alert
              class="alerta"
              color="#00796b"
              type="info"
              dense
              outlined
            >
              Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.
            </v-alert>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Apresentação"
            :value="this.extensaoe.apresentacao  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Justificativa / Mérito extensionista"
            :value="this.extensaoe.justificativa  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row v-if="this.extensaoe.caracterizacaoPublicoAlvo">
          <v-flex xs12>
            <c-readonly-field
            label="Caracterização do público-alvo"
            :value="this.extensaoe.caracterizacaoPublicoAlvo  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap text-xs-left v-if="!this.extensaoe.caracterizacaoPublicoAlvo">
          <v-flex xs12 class="publicoAlvo">
            <label>Caracterização do público-alvo</label>
          </v-flex>
        </v-layout>

        <v-layout row v-if="!this.extensaoe.caracterizacaoPublicoAlvo && projeto.tipoPublico.item === 1">
          <v-flex xs12>
            <c-readonly-field
            label="• Interno:"
            :value="this.extensaoe.publicoAlvoInterno  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row v-if="!this.extensaoe.caracterizacaoPublicoAlvo">
          <v-flex xs12>
            <c-readonly-field
            label="• Externo:"
            :value="this.extensaoe.publicoAlvoExterno  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Objetivo geral"
            :value="this.extensaoe.objetivosGerais || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>


        <v-layout row>
          <v-flex xs12>
            <label class="labelObjetivosEspecificos">Objetivos específicos</label>
            <v-list class="listObjetivosEspecificos">
              <v-list-item v-for="(item, index) in objetivosEspecificosTopicos" :key="item.id" style="padding: 0px;">
                <v-list-item-content align="justify">
                  {{index+1}}. {{item.nome}}
                </v-list-item-content>
                <p class="mt-3"></p>
              </v-list-item>
            </v-list>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Metodologia"
            :value="this.extensaoe.metodologia || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Formas de avaliação -->
        <v-layout row>

          <v-flex xs12>

            <!-- Curso ou Oficina de Extensão -->
            <c-readonly-field
            v-if="extensaoe.curso || extensaoe.oficina"
            label="Formas de avaliação dos cursistas"
            :value="this.extensaoe.formaAvaliacao || '-'"
            align="justify"
            ></c-readonly-field>

            <!-- Demais tipos de ação de extensão -->
            <c-readonly-field
            v-else
            label="Forma de avaliação"
            :value="this.extensaoe.formaAvaliacao || '-'"
            align="justify"
            ></c-readonly-field>

          </v-flex>

        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Infraestrutura física" :value="this.extensaoe.infraestruturaFisica  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Apresentar justificativa pelo cadastro/envio da ação ter sido realizado em prazo inferior ao estabelecido pela Instrução Normativa nº 02/2016 >
        <v-layout row v-if="this.prazo < 30 && !this.extensaoe.registroSIEX">
          <v-flex xs12>
            <c-readonly-field
            label="Apresentar justificativa pelo cadastro/envio da ação ter sido realizado em prazo inferior ao estabelecido pela Instrução Normativa nº 02/2016"
            :value="this.extensaoe.justificativaPrazo  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>
        <v-layout-- row v-if="this.prazo < 30 && !this.extensaoe.registroSIEX">
          <v-flex xs12>
            <v-alert
              class="alertaPrazo"
              color="#00796b"
              type="info"
              dense
              outlined
            >
              O coordenador de Ação de Extensão deverá proceder ao registro prévio e encaminhamento da documentação pertinente à PROEX, com antecedência mínima de 30 (trinta) dias úteis ao início da Ação, conforme Instrução Normativa nº 02/2016.
            </v-alert>
          </v-flex>
        </v-layout-->

        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Informações adicionais"
            :value="this.extensaoe.informacoesAdicionais  || '-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.length === 0">
          <v-flex xs12>
            <c-readonly-field
            label="Tipo de Prestação de Serviço"
            :value="'-'"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.length !== 0">
          <v-flex xs12>
            <v-select
              v-model="listaTiposPrestacaoServicoSelecionados"
              :items="listaTiposPrestacaoServico"
              chips
              multiple
              readonly
            >
            <template v-slot:label><div style="font-size: 1.2em">Tipo de Prestação de Serviço</div></template>
            </v-select>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <p class="tipoPrestacaoServico">Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia</p>
            <!-- Espaços e Museus Culturais -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Espaços e Museus Culturais"
            readonly
            >
            <template v-slot:label><div>Espaços e Museus Culturais</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <!-- Espaços e Museus de Ciência e Tecnologia -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Espaços e Museus de Ciência e Tecnologia"
            readonly
            >
            <template v-slot:label><div>Espaços e Museus de Ciência e Tecnologia</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <!-- Cines-clube -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Cines-clube"
            readonly
            >
            <template v-slot:label><div>Cines-clube</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <!-- Outros -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Outros"
            readonly
            >
            <template v-slot:label><div>Outros</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Serviço eventual</p>
            <!-- Nº de assessorias -->
            <c-readonly-field
              label='Nº de assessorias'
              v-model="this.extensaoe.numAssessorias"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <!-- Nº de consultorias -->
            <c-readonly-field
              label='Nº de consultorias'
              v-model="this.extensaoe.numConsultorias"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <!-- Nº de curadorias -->
            <c-readonly-field
              label='Nº de curadorias'
              v-model="this.extensaoe.numCuradorias"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <!-- Nº de outros -->
            <c-readonly-field
              label='Nº de outros'
              v-model="this.extensaoe.numOutrosServicos"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atividades de propriedade intelectual</p>
            <!-- Nº de depósito de patentes e modelos de utilidades -->
            <c-readonly-field
              label='Nº de depósito de patentes e modelos de utilidades'
              v-model="this.extensaoe.numPatentesModelos"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <!-- Nº de registro de marcas e softwares -->
            <c-readonly-field
              label='Nº de registro de marcas e softwares'
              v-model="this.extensaoe.numMarcasSoftwares"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <!-- Nº de contratos de transferência de tecnologia -->
            <c-readonly-field
              label='Nº de contratos de transferência de tecnologia'
              v-model="this.extensaoe.numTransferenciaTecnologia"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <!-- Nº de registros de direitos autorais -->
            <c-readonly-field
              label='Nº de registros de direitos autorais'
              v-model="this.extensaoe.numDireitosAutorais"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Exames e laudos técnicos) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Exames e laudos técnicos</p>
            <!-- Nº de laudos emitidos -->
            <c-readonly-field
              label='Nº de laudos emitidos'
              v-model="this.extensaoe.numLaudosEmitidos"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento jurídico) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atendimento jurídico</p>
            <!-- Nº de atendimentos -->
            <c-readonly-field
              label='Nº de atendimentos'
              v-model="this.extensaoe.numAtendimentosJuridicos"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atendimento em saúde humana</p>
            <!-- Nº de consultas ambulatoriais (programadas) -->
            <c-readonly-field
              label='Nº de consultas ambulatoriais (programadas)'
              v-model="this.extensaoe.numConsultasAmbulatoriais"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de consultas de emergência e urgência -->
            <c-readonly-field
              label='Nº de consultas de emergência e urgência'
              v-model="this.extensaoe.numConsultasEmergencia"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de internações -->
            <c-readonly-field
              label='Nº de internações'
              v-model="this.extensaoe.numInternacoes"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de cirurgias -->
            <c-readonly-field
              label='Nº de cirurgias'
              v-model="this.extensaoe.numCirurgias"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de exames laboratoriais -->
            <c-readonly-field
              label='Nº de exames laboratoriais'
              v-model="this.extensaoe.numExamesLaboratoriais"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de exames complementares -->
            <c-readonly-field
              label='Nº de exames complementares'
              v-model="this.extensaoe.numExamesComplementares"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de outros atendimentos -->
            <c-readonly-field
              label='Nº de outros atendimentos'
              v-model="this.extensaoe.numOutrosAtendimentosSH"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atendimento em saúde animal</p>
            <!-- Nº de atendimentos veterinários ambulatoriais -->
            <c-readonly-field
              label='Nº de atendimentos veterinários ambulatoriais'
              v-model="this.extensaoe.numAtendimentosVeterinarios"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <!-- Nº de internações veterinárias -->
            <c-readonly-field
              label='Nº de internações veterinárias'
              v-model="this.extensaoe.numInternacoesVeterinarias"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <!-- Nº de cirurgias veterinárias -->
            <c-readonly-field
              label='Nº de cirurgias veterinárias'
              v-model="this.extensaoe.numCirurgiasVeterinarias"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <!-- Nº de exames laboratoriais e complementares em veterinária -->
            <c-readonly-field
              label='Nº de exames laboratoriais e complementares em veterinária'
              v-model="this.extensaoe.numExamesVeterinaria"
              :rules="campoNumericoRules"
              >
            </c-readonly-field>
          </v-flex>
        </v-layout>

        <p v-if="this.extensaoe.prestacaoServico && listaTiposPrestacaoServicoSelecionados.length !== 0" class="mt-3"></p>

        <br>

        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <c-readonly-field
            label="Possui vínculo com ensino"
            :value="extensaoe.vinculoEnsino != null ? (extensaoe.vinculoEnsino ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <c-readonly-field
            label="Possui vínculo com pesquisa"
            :value="extensaoe.vinculoPesquisa != null ? (extensaoe.vinculoPesquisa ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Esta ação realiza divulgação científica -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <c-readonly-field
            label="Esta ação realiza divulgação científica"
            :value="extensaoe.divulgacaoCientifica != null ? (extensaoe.divulgacaoCientifica ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Esta é uma ação direcionada às escolas públicas -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <c-readonly-field
            label="Esta é uma ação direcionada às escolas públicas (alunos, professores, servidores ou processo de formação continuada)"
            :value="extensaoe.direcionadaEscolaPublica != null ? (extensaoe.direcionadaEscolaPublica ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES -->
        <v-layout row wrap justify-space-between>
          <v-flex xs6>
            <c-readonly-field
            label="Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES"
            :value="extensaoe.creditacaoGraduacao != null ? (extensaoe.creditacaoGraduacao ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
          <v-flex xs6>
            <c-readonly-field
            label="Data inicial da creditação"
            :value="extensaoe.dtInicialCreditacao ? dates.format(extensaoe.dtInicialCreditacao) || '-' : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Envolve captação de recursos financeiros ou bens duráveis -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <c-readonly-field
            label="Envolve captação de recursos financeiros ou bens duráveis"
            :value="extensaoe.captacaoRecursosBensDuraveis != null ? (extensaoe.captacaoRecursosBensDuraveis ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Por meio de: -->
        <v-layout row wrap justify-space-between v-if="extensao.captacaoRecursosBensDuraveis === true">
          <v-flex xs12>
            <label>Por meio de:</label>
          </v-flex>
        </v-layout>

        <!-- UFES, CAPES e FEST -->
        <v-layout row wrap justify-space-between v-if="extensao.captacaoRecursosBensDuraveis === true">

          <!-- UFES -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.captacaoRecursosUfes"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">UFES</div></template>
            </v-checkbox>
          </v-flex>

          <!-- CAPES -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.captacaoRecursosCapes"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">CAPES</div></template>
            </v-checkbox>
          </v-flex>

          <!-- FEST -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.captacaoRecursosFest"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">FEST</div></template>
            </v-checkbox>
          </v-flex>

        </v-layout>

        <!-- CNPq, FAPES e FUCAM -->
        <v-layout row wrap justify-space-between v-if="extensao.captacaoRecursosBensDuraveis === true">

          <!-- CNPq -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.captacaoRecursosCnpq"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">CNPq</div></template>
            </v-checkbox>
          </v-flex>

          <!-- FAPES -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.captacaoRecursosFapes"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">FAPES</div></template>
            </v-checkbox>
          </v-flex>

          <!-- FUCAM -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.captacaoRecursosFucam"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">FUCAM</div></template>
            </v-checkbox>
          </v-flex>

        </v-layout>

        <!-- Outros e Especifique -->
        <v-layout row wrap justify-space-between v-if="extensao.captacaoRecursosBensDuraveis === true">

          <!-- Outros -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.captacaoRecursosOutros"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">Outros</div></template>
            </v-checkbox>
          </v-flex>

          <!-- Especifique -->
          <v-flex xs8 sm8 v-if="extensao.captacaoRecursosBensDuraveis === true" >
            <c-readonly-field
            label="Especifique:"
            v-model="extensao.especCaptacaoRecursosOutros"
            >
            </c-readonly-field>
          </v-flex>

        </v-layout>

        <!-- Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <c-readonly-field
            label="Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação"
            :value="extensaoe.liberacaoCargaHoraria != null ? (extensaoe.liberacaoCargaHoraria ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Carga horária aprovada -->
        <v-layout row wrap justify-space-between v-if="extensaoe.liberacaoCargaHoraria === true">
          <v-flex xs12>
            <c-readonly-field
            label="Carga horária aprovada"
            :value="this.extensaoe.cargaHorariaCoordenadorAprovada || '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Gratuito para o público -->
        <v-layout row wrap justify-space-between v-if="extensaoe.curso || extensaoe.oficina || extensaoe.evento">
          <v-flex xs12>
            <c-readonly-field
            label="Gratuito para o público"
            :value="extensaoe.gratuito != null ? (extensaoe.gratuito ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Os recursos financeiros obtidos serão administrados por: -->
        <v-layout row wrap justify-space-between v-if="extensao.gratuito === false">
          <v-flex xs12>
            <label>Os recursos financeiros obtidos serão administrados por:</label>
          </v-flex>
        </v-layout>

        <!-- UFES -->
        <v-layout row wrap justify-space-between v-if="extensao.gratuito === false">
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.gratuitoUfes"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">UFES</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- FEST-->
        <v-layout row wrap justify-space-between v-if="extensao.gratuito === false">
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.gratuitoFest"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">FEST</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- FUCAM -->
        <v-layout row wrap justify-space-between v-if="extensao.gratuito === false">
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.gratuitoFucam"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">FUCAM</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Outros e Especifique -->
        <v-layout row wrap justify-space-between v-if="extensao.gratuito === false">

          <!-- Outros -->
          <v-flex xs4 sm4>
            <v-checkbox
            v-model="extensao.gratuitoOutros"
            readonly
            >
            <template v-slot:label><div class="v-checkbox_label">Outros</div></template>
            </v-checkbox>
          </v-flex>

          <!-- Especifique -->
          <v-flex xs8 sm8>
            <c-readonly-field
            v-if="extensao.gratuito === false"
            label="Especifique:"
            v-model="extensao.especGratuitoOutros"
            >
            </c-readonly-field>
          </v-flex>

        </v-layout>

        <!-- Modalidade -->
        <v-layout row wrap justify-space-between v-if="extensaoe.curso || extensaoe.oficina">
          <v-flex xs12>
            <c-readonly-field
            label="Modalidade"
            :value="extensaoe.modalidade != null ? (extensaoe.modalidade == 'P' ? 'Presencial' : (extensaoe.modalidade == 'S' ? 'Semipresencial' : 'EAD')) : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Utiliza o AVA Extensão -->
        <v-layout row wrap justify-space-between v-if="extensaoe.curso || extensaoe.oficina">
          <v-flex xs12>
            <c-readonly-field
            label="Utiliza o AVA Extensão"
            :value="extensaoe.utilizaAvaExtensao != null ? (extensaoe.utilizaAvaExtensao ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Outra plataforma AVA -->
        <v-layout row wrap justify-space-between v-if="extensaoe.curso || extensaoe.oficina">
          <v-flex xs12>
            <c-readonly-field
            label="Outra plataforma AVA"
            :value="extensaoe.plataforma || '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Suspensões -->
        <v-layout row wrap justify-space-between v-if="listaSuspensoes.length !== 0">
          <v-flex xs12>
          <label>Suspensões</label>
          </v-flex>
        </v-layout>

        <v-data-table v-if="listaSuspensoes.length !== 0"
          class="elevation-1 suspensoes"
          :headers="headersSuspensoes"
          :header-props="{ sortIcon: null }"
          :items="listaSuspensoes"
          :items-per-page="-1"
          hide-default-footer
        >
          <!-- Formata data de início da suspensão -->
          <template v-slot:item.dtInicioSuspensao="props">{{dates.format(props.item.dtInicioSuspensao)}}</template>

          <!-- Formata data de fim da suspensão -->
          <template v-slot:item.dtFimSuspensao="props">{{dates.format(props.item.dtFimSuspensao)}}</template>

        </v-data-table>

        <!-- Caso a ação de extensão não tenha suspensões -->
        <v-layout row wrap justify-space-between v-if="listaSuspensoes.length === 0">
          <v-flex xs12>
          <c-readonly-field
            label="Suspensões"
            value="-"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Registro de relatórios enviados -->
        <v-layout row wrap justify-space-between v-if="listaRegistroRelatoriosEnviados.length !== 0">
          <v-flex xs12>
          <label>Registro de relatórios enviados</label>
          </v-flex>
        </v-layout>

        <v-data-table v-if="listaRegistroRelatoriosEnviados.length !== 0"
          class="elevation-1 suspensoes"
          :headers="headersRegistroRelatoriosEnviados"
          :header-props="{ sortIcon: null }"
          :items="listaRegistroRelatoriosEnviados"
          :items-per-page="-1"
          hide-default-footer
        >
          <!-- Formata data de início da suspensão -->
          <template v-slot:item.dtEnvio="props">{{dates.format(props.item.dtEnvio)}}</template>
        </v-data-table>

        <!-- Caso a ação de extensão não tenha suspensões -->
        <v-layout row wrap justify-space-between v-if="listaRegistroRelatoriosEnviados.length === 0">
          <v-flex xs12>
          <c-readonly-field
            label="Registro de relatórios enviados"
            value="-"
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="IntegrantesProjeto"
      editar="EditarExtensao"
      nome_editar="Editar"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
    </c-card-footer>

  </div>
</template>

<script>
import CardFooter from '@/components/c-card-footer'
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import projetos from '@/utils/projetos'
import dates from '@/utils/dates'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    dates: dates,
    listaSuspensoes: [],
    listaRegistroRelatoriosEnviados: [],
    headersSuspensoes: [
      { text: 'Início', align: 'left', value: 'dtInicioSuspensao' },
      { text: 'Fim', align: 'left', value: 'dtFimSuspensao' },
      { text: 'Processo', left: 'left', value: 'processo' }
    ],
    headersRegistroRelatoriosEnviados: [
      { text: 'Data de envio', align: 'left', value: 'dtEnvio' },
      { text: 'Número do relatório', align: 'left', value: 'numRelatorio' }
    ],
    objetivosEspecificosTopicos: [],
    listaTiposPrestacaoServicoSelecionados: [],
    listaTiposPrestacaoServico: [
      'Atendimento ao público em espaços de cultura, ciência e tecnologia',
      'Serviço eventual',
      'Atividades de propriedade intelectual',
      'Exames e laudos técnicos',
      'Atendimento jurídico',
      'Atendimento em saúde humana',
      'Atendimento em saúde animal'
    ],
    listaAtendimentoPublicoEspacosSelecionados: [],
    prazo: 30,
    extensaoe: {}
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING'])
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
    projetos.getExtensaoDoProjeto(this.idProjeto)
    .then(response => {
      this.extensaoe = response.data
      let aux = this.extensaoe.objetivosEspecificos.split(';;')
      for (let item in aux) {
        this.objetivosEspecificosTopicos.push({id: item, nome: aux[item]})
      }

      // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
      if (this.extensaoe.atendimentoPublicoEspacos === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento ao público em espaços de cultura, ciência e tecnologia')
      }

      // Tipo de Prestação de Serviço (Serviço eventual)
      if (this.extensaoe.servicoEventual === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Serviço eventual')
      }

      // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
      if (this.extensaoe.atividadesPropriedadeIntelectual === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atividades de propriedade intelectual')
      }

      // Tipo de Prestação de Serviço (Exames e laudos técnicos)
      if (this.extensaoe.examesLaudosTecnicos === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Exames e laudos técnicos')
      }

      // Tipo de Prestação de Serviço (Atendimento jurídico)
      if (this.extensaoe.atendimentoJuridico === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento jurídico')
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde humana)
      if (this.extensaoe.atendimentoSaudeHumana === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde humana')
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde animal)
      if (this.extensaoe.atendimentoSaudeAnimal === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde animal')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
      if (this.extensaoe.espacosMuseusCulturais === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus Culturais')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
      if (this.extensaoe.espacosMuseusCT === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus de Ciência e Tecnologia')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
      if (this.extensaoe.cinesClube === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Cines-clube')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
      if (this.extensaoe.outrosEspacos === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Outros')
      }
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
    })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
    projetos.getPrazoDias(this.idProjeto)
    .then(response => {
      this.prazo = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
    })

    // Carrega as suspensões de uma ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' })
    projetos.getSuspensoes(this.idProjeto)
    .then(response => {
      this.listaSuspensoes = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' })
    })

    // Carrega os registros de envio de relatórios
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando registros de envios de relatórios...' })
    projetos.getRegistrosDeEnvioDeRelatorioDeProjeto(this.idProjeto)
    .then(response => {
      this.listaRegistroRelatoriosEnviados = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando registros de envios de relatórios...' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter,
    'c-readonly-field': ReadonlyField
  }
}
</script>
<style>
  .labelObjetivosEspecificos {
    color: '#646464';
    font-size: 14px;
    padding: 0px !important;
    margin: 0px !important;
  }
  .listObjetivosEspecificos {
    color: gray;
    font-size: 16px;
    overflow-wrap: break-word;
    padding: 0px !important;
    margin: 0px !important;
  }
</style>
<style lang="css">

  .v-checkbox_label {
    font-size: 11pt;
  }

  .publicoAlvo {
    margin-bottom: 1.0em;
  }

  .tipoPrestacaoServico {
    font-size: 1.10em;
    margin-top: 1em;
  }

  .alerta {
    margin-top: 0;
    font-size: 0.85em;
  }

</style>

<style scoped>

  .alertaPrazo {
    margin: 0.5em 0 2.0em 0;
    font-size: 0.85em;
    text-align: justify;
  }

  .suspensoes {
    margin-top: 2em;
    margin-bottom: 2em;
    margin-left: -1em;
    margin-right: auto;
  }

</style>



// WEBPACK FOOTER //
// projeto-extensao.vue?4c383362